export default __webpack_public_path__ + "static/media/Flag_of_Turkey.eb344dd2.svg";